import { render, staticRenderFns } from "./AboutBox.vue?vue&type=template&id=3d5d75be&scoped=true"
import script from "./AboutBox.vue?vue&type=script&lang=js"
export * from "./AboutBox.vue?vue&type=script&lang=js"
import style0 from "./AboutBox.vue?vue&type=style&index=0&id=3d5d75be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5d75be",
  null
  
)

export default component.exports